import Vue from 'vue'
import Vuex from 'vuex'

import auth from './auth'
import items from './items'
import components from './components'
import noteTemplates from './noteTemplates'
import componentInstances from './componentInstances'
import ui from './ui'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    auth,
    items,
    components,
    noteTemplates,
    componentInstances,
    ui
  }
})

export default store
